import { useState } from 'react';
import { DropDown } from '../../../component/dropDown';
import { EmptyState, EmptyTxt } from '../../../component/emptyState';
import { Loader } from '../../../component/loader';
import { DeleteModal } from '../../../component/modal/deleteModal';
import {
  useDeleteAgentMutation,
  useFetchAgentQuery
} from '../../../store/agent/api';
import { modules } from '../../../utils/module';
import { states } from '../../../utils/nigeriaSates';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { generateUrl } from '../../../utils/urlGenerator';
import { AddAgent } from '../modals/addAgent';
import { AgentCard } from './component/agentCard';
import {
  AddBtn,
  Container,
  Header,
  ListContainer,
  SortContainer,
  SortText,
  StateDropDown,
  Title
} from './styles';

export const AllAgents = () => {
  const [sortByType, setSortByType] = useState('');
  const [deleteAgentModal, setDeleteAgentModal] = useState(false);
  const [deleteAgent, { isLoading: isDeletingAgent }] =
    useDeleteAgentMutation();
  const [agentId, setAgentId] = useState<string>('');
  const [sortByState, setSortByState] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const { data: agents, isLoading: isLoadingAgents } = useFetchAgentQuery(
    generateUrl({
      state: sortByState,
      module: sortByType.toLowerCase().replace(' ', '-')
    })
  );
  const handleDeleteAgent = (itemId: string) => {
    setDeleteAgentModal(true);
    setAgentId(itemId);
  };
  const handleAgentDelete = () => {
    deleteAgent(agentId)
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
        setDeleteAgentModal(false);
      })
      .catch((error) => {
        showErrorToast(error.message);
      });
  };
  return (
    <Container>
      {isLoadingAgents && <Loader />}
      {showAddModal && <AddAgent setShow={setShowAddModal} />}
      {deleteAgentModal && (
        <DeleteModal
          deleteTitle="Delete agent"
          isLoading={isDeletingAgent}
          deleteText="Are you sure you want to delete this agent, this action can’t be undone?"
          deleteBtnClick={handleAgentDelete}
          cancelBtnClick={() => setDeleteAgentModal(false)}
        />
      )}
      <Header>
        <Title>All agents</Title>
        <AddBtn onClick={() => setShowAddModal(true)}>Add agent</AddBtn>
      </Header>
      <SortContainer>
        <SortText>Sort by</SortText>
        <DropDown
          value={sortByType}
          placeholder={'All agent'}
          onSelect={(item) => {
            setSortByType(item === 'All agent' ? '' : item);
          }}
          options={['All agent', ...modules]}
        />
        <StateDropDown
          value={sortByState}
          placeholder={'All state'}
          onSelect={(item) => {
            setSortByState(item === 'All state' ? '' : item);
          }}
          options={['All state', ...states]}
        />
      </SortContainer>
      {agents?.data.fetchedData.length ? (
        <ListContainer>
          {agents?.data.fetchedData.map((agent, index) => (
            <AgentCard
              key={index.toString()}
              agent={agent}
              handleDelete={() => handleDeleteAgent(agent._id)}
            />
          ))}
        </ListContainer>
      ) : (
        <EmptyState>
          <EmptyTxt>
            No SOJI agents yet, click on the button below to add SOJI agents
          </EmptyTxt>
          <AddBtn onClick={() => setShowAddModal(true)}>Add agent</AddBtn>
        </EmptyState>
      )}
    </Container>
  );
};
